<template>
  <div>
    <div class="content-wrapper">
      <section class="content-header">
        <h1>
          Payment Methods
          <small>List of payment methods</small>
        </h1>
        <ol class="breadcrumb">
          <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
          <li>Operation Tools</li>
          <li class="active">Payment Methods</li>
        </ol>
      </section>

      <section class="content">
        <div class="box">
          <div class="box-header">
            <a class="btn btn-success pull-right"
              @click.prevent="add">
              Add New Payment Method
            </a>
          </div>

          <div class="box-body">
            <template v-if="paymentMethods">
              <table id="table" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Payment Method</th>
                    <th>Key</th>
                    <th class="text-center">Status</th>
                    <th class="text-center" style="width: 12rem">Action(s)</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, index) in paymentMethods" :key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ item.key }}</td>
                    <td class="text-center">
                      <a class="btn btn-xs"
                        @click="toggleStatus(item)"
                        :class="{
                          'btn-success': item.status == 1,
                          'btn-default': item.status == 0,
                        }">
                        <template v-if="item.status == 0">Disabled</template>
                        <template v-else>Enabled</template>
                      </a>
                    </td>
                    <td class="text-center">
                      <a class="btn btn-primary btn-xs"
                        @click="edit(item.id)">
                        Edit
                      </a>
                      <a class="btn btn-danger btn-xs"
                        @click="remove(item)">
                        Delete
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>

          <div class="box-footer">
            <Pagination
              :pagination="pagination"
              @goto-page="changePage" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      paymentMethods: [],
      pagination: {},
    };
  },

  methods: {
    fetch(page) {
      const pageQuery = this.$route.query.page;

      const params = {
        page: page || pageQuery,
      };

      this.axios.get('/payments/method', { params })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            return;
          }

          this.paymentMethods = data;
          this.pagination = meta.pagination;
        });

      if (page) {
        window.history.pushState(`Payment methods page: ${page}`, null, `/payment-methods?page=${page}`);
      }
    },

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push('/payment-methods/create');
    },

    edit(value = null) {
      this.$router.push({
        name: 'payment-methods-edit',
        params: {
          id: value,
          page: 'edit',
        },
      });
    },

    toggleStatus(item) {
      const params = (item.is_enabled === 1) ? `deactivate/${item.id}` : `activate/${item.id}`;

      this.axios.patch(`/payments/method/${params}`)
        .then(() => {
          this.fetch();
        });
    },

    delete(id) {
      return new Promise((resolve, reject) => {
        this.axios.delete(`/payments/method/${id}`)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      });
    },

    remove(item) {
      return this.$swal({
        title: 'Delete Method',
        text: `Are you sure to delete ${item.name}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          (async () => {
            try {
              await this.delete(item.id);
              await this.fetch();
              this.$swal({
                title: 'Deleted!',
                text: `${item.name} has been deleted.`,
                type: 'success',
                timer: 2000,
              });
            } catch (error) {
              console.log(error);
            }
          })();
        }
      });
    },
  },

  created() {
    this.fetch();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/operation/payment/methods/Main.vue